import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchRules() {
  const { data } = await axios.get(`${API}/rules`);
  return data;
}

export async function runAssessment(profile) {
  const { data } = await axios.post(`${API}/assess`, profile);
  return data;
}

export async function fetchStreams() {
  const { data } = await axios.get(`${API}/streams`);
  return data;
}

export async function runStreamAssessment(streamId, profile) {
  const { data } = await axios.post(`${API}/assess/stream/${streamId}`, profile);
  return data;
}

export async function searchNoc(q) {
  const { data } = await axios.get(`${API}/noc`, { params: { q } });
  return data;
}

export async function fetchDraws() {
  const { data } = await axios.get(`${API}/draws`);
  return data;
}

export async function createShare(result, profile) {
  const { data } = await axios.post(`${API}/share`, { result, profile });
  return data;
}

export async function fetchShare(code) {
  const { data } = await axios.get(`${API}/share/${code}`);
  return data;
}

export async function submitLead(assessmentId, email) {
  const { data } = await axios.post(`${API}/leads`, { assessment_id: assessmentId, email });
  return data;
}

export async function createAlert({ email, streamId, score, assessmentId }) {
  const { data } = await axios.post(`${API}/alerts`, { email, stream_id: streamId, score, assessment_id: assessmentId || null });
  return data;
}

export async function submitFeedback({ rating, comment, page, streamId, assessmentId }) {
  const { data } = await axios.post(`${API}/feedback`, { rating, comment: comment || "", page, stream_id: streamId || null, assessment_id: assessmentId || null });
  return data;
}

export async function unsubscribeAlert(token) {
  const { data } = await axios.post(`${API}/alerts/unsubscribe/${token}`);
  return data;
}

export async function downloadPdf(kind, result, profile) {
  const { data, headers } = await axios.post(`${API}/export/pdf`, { kind, result, profile }, { responseType: "blob" });
  const match = /filename="([^"]+)"/.exec(headers["content-disposition"] || "");
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : "prpathfinder-report.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
